import { produce } from 'immer'
import type { State } from '../../typings'

export const removeActivityProducer = produce<State, [number]>(
  (draft, payload) => {
    const rowIndex = draft.tableState.rows.findIndex((x) => x.id === payload)
    if (rowIndex !== -1) {
      draft.tableState.rows.splice(rowIndex, 1)
    }
  },
)
